import React, { useEffect, useState, useRef, useCallback } from "react";
import { Accordion, Card } from "react-bootstrap";
import { connect } from 'react-redux';
import { vtoConstants } from "../VTOConstants";
import { Button } from "react-bootstrap";
import "../VoluntaryTOffComponent.scss";
import "./predictions/VTOStaffingPredictions.scss";
import strings from "../../../resources/strings.json";
import { getClassificationOptions, getDutyAssignmentOptions, getStationTimestamp, validateOfferTimes, updateAllOfferErrors, setCutOffTime, buildOffersResponse, createSearchCriteria, isAfter2330, validateFields } from '../utils';
import { useHistory, useLocation } from "react-router-dom";
import moment from "moment";
import NewOfferComponent from "./newOfferComponent";
import CurrentOffers from "./currentOffersComponent";
import infoIcon from "../../../assets/images/about_icon.svg";
import ConfirmationPopUp from "../confirmationPopUp";
import DuplicateOfferModal from "./modals/DuplicateOfferModal";
import SlotsSuccessModal from "./modals/SlotsSuccessModal";
import LeadingIcon from '../../../assets/images/icons/leading-icon.svg';
import SuggestionPopup from "./predictions/suggestionPopup";

// Import custom hooks
import { useAutoFill, useOfferValidation, useDuplicateOffers } from './hooks';

// Import sub-components
import {
    AutoFillConfirmationPopup,
    DateSelector,
    DropdownFilters
} from './components';

// Default offer template
const DEFAULT_OFFER = {
    "id": 0,
    "offerEndTimeHr": "",
    "offerEndTimeMin": "",
    "offerStartTimeHr": "",
    "offerStartTimeMin": "",
    "duration": "",
    "slots": 1,
    "error": false,
    "note": "",
    "classification": "",
    "dutyAssignment": "",
    "cdaError": false,
    "cutOffTime": {}
};

const CreateOfferscreen = (props) => {
    const history = useHistory();
    const location = useLocation();

    // ==================== Refs for Card Positioning ====================
    const accordionRef = useRef(null);
    const accordionItemRefs = useRef({});
    const [cardTopPosition, setCardTopPosition] = useState(0);

    const getBaseMoment = (baseTime) => {
        if (!baseTime) return moment();
        const cleanBaseTime = typeof baseTime === 'string' ? baseTime.split('.')[0] : baseTime;
        return moment(cleanBaseTime);
    };

    const buildThreeDatesFromBase = (baseTime) => {
        const baseMoment = getBaseMoment(baseTime);
        return [0, 1, 2].map(offset => moment(baseMoment).add(offset, 'days').format('MM/DD/YYYY'));
    };

    const [availableDates, setAvailableDates] = useState(buildThreeDatesFromBase());
    const [selectedDates, setSelectedDates] = useState([]);
    const [dateShown, setDateShown] = useState("");
    const [isFlashOffer, setIsFlashOffer] = useState(false);

    // ==================== Station & Department State ====================
    const [selectedStation, setSelectedStation] = useState("");
    const [stationOptions, setStationOptions] = useState(props.stationList || []);
    const [selectedDepartment, setSelectedDepartment] = useState("");
    const [departmentOptions] = useState(['Customer Care', 'Customer Operations']);
    const [selectedDutyAssig, setSelectedDutyAssig] = useState("");
    const [dutyAssigOptions, setDutyAssigOptions] = useState([]);
    const [classificationOptions, setClassificationOptions] = useState([]);
    const [selectedClassification, setSelectedClassification] = useState("");
    const [selectedWorkLoc, setSelectedWorkLoc] = useState("");
    const [isStationError, setIsStationError] = useState(false);
    const [stationTime, setStationTime] = useState(null);

    // ==================== Offer State ====================
    const [isCheckedApplyAll, setisCheckedApplyAll] = useState(true);
    const [offerDetails, setOfferDetails] = useState({ ...DEFAULT_OFFER });
    const [activeKey, setActiveKey] = useState(null);
    const [offersConsolidation, setOffersConsolidation] = useState({});

    // ==================== UI State ====================
    const [showCDAError, setShowCDAError] = useState(false);
    const [showRequiredFieldsError, setShowRequiredFieldsError] = useState(false);
    const [showSubmitPopup, setShowSubmitPopup] = useState(false);
    const [offersSummary, setOffersSummary] = useState({});
    const [showSlotsSuccessModal, setShowSlotsSuccessModal] = useState(false);

    // ==================== Suggestion State ====================
    const [showSuggestion] = useState(!props.suggestion);
    const [suggestionDetails] = useState(location.state?.suggestion);
    const [showSuggestionModal, setShowSuggestionModal] = useState(false);
    const [vtoOpportunities] = useState(location.state?.suggestion?.cardDetails?.vtoOpportunities || []);
    const [hasAppliedSuggestion, setHasAppliedSuggestion] = useState(false);
    const [addedOffers, setAddedOffers] = useState(new Set());

    // ==================== Custom Hooks ====================

    // Validation Hook
    const {
        showError,
        errorMessage,
        setShowError,
        setErrorMessage,
        setValidationError,
        clearValidationError,
        hasSelectionError
    } = useOfferValidation({
        offersConsolidation,
        setOffersConsolidation,
        selectedDates,
        stationTime
    });

    // Duplicate Offers Hook
    const {
        showDuplicateModal,
        duplicateOffers,
        duplicateResolutions,
        selectedOfferForSlots,
        setShowDuplicateModal,
        setDuplicateOffers,
        setDuplicateResolutions,
        setSelectedOfferForSlots,
        resetDuplicateModalState,
        handleConfirmDuplicateResolutions,
        checkForDuplicates,
        initializeDuplicateResolutions
    } = useDuplicateOffers({
        offersConsolidation,
        setOffersConsolidation,
        selectedDates,
        selectedStation,
        selectedDepartment,
        selectedWorkLoc,
        selectedClassification,
        selectedDutyAssig,
        setOffersSummary,
        setShowSubmitPopup,
        setShowSlotsSuccessModal,
        updateSlotsRequest: props.updateSlotsRequest
    });

    // Auto-Fill Hook
    const {
        showAutoFillPopup,
        pendingAutoFillData,
        handleAutoFillOffer,
        handleAutoFillOverwrite,
        handleAutoFillCreateNew,
        closeAutoFillPopup
    } = useAutoFill({
        offersConsolidation,
        setOffersConsolidation,
        setOfferDetails,
        activeKey,
        setActiveKey,
        selectedDates,
        selectedStation,
        selectedDepartment,
        selectedClassification,
        selectedDutyAssig,
        isCheckedApplyAll,
        stationTime,
        setShowRequiredFieldsError,
        setShowCDAError,
        setErrorMessage,
        setShowError,
        onSuccess: (offerKey) => setAddedOffers(prev => new Set(prev).add(offerKey))
    });

    // ==================== Helper Functions ====================

    const hasMultipleRoleTypes = () => vtoOpportunities && vtoOpportunities.length > 1;
    // ==================== Handlers ====================

    const handleAddNewOffer = (offer) => {
        if ((activeKey || activeKey === "0") && hasSelectionError(activeKey)) return;
        if (activeKey != null && Number(activeKey) >= 0 && !isCheckedApplyAll &&
            (!offersConsolidation[activeKey].classification || !offersConsolidation[activeKey].dutyAssignment)) {
            let previousOffers = { ...offersConsolidation };
            let currentOffer = { ...offersConsolidation[activeKey] };
            currentOffer.cdaError = true;
            setShowCDAError(true);
            previousOffers[activeKey] = currentOffer;
            setOffersConsolidation(previousOffers);
            return;
        }
        if (activeKey && offersConsolidation[activeKey].error) return;

        let currentCount = Object.keys(offersConsolidation).length > 0
            ? Number(Object.keys(offersConsolidation)[Object.keys(offersConsolidation).length - 1]) + 1
            : 0;
        let currentOffers = { ...offersConsolidation };

        let newOffer = {
            ...DEFAULT_OFFER,
            "id": currentCount,
            "cutOffTime": selectedDates.reduce((acc, date) => {
                acc[date] = setCutOffTime(date, stationTime);
                return acc;
            }, {}),
        };
        setOfferDetails(newOffer);
        setOffersConsolidation({ ...currentOffers, [newOffer.id]: { ...newOffer } });
        setActiveKey(currentCount.toString());
    };

    const handleDeleteOffer = (e) => {
        hasSelectionError(activeKey);
        if (Object.keys(offersConsolidation).length === 0) return;

        // Use data-offer-id (stable offer.id) with fallback to DOM id
        const currentTarget = e?.currentTarget;
        const idToDelete = String(
            currentTarget?.dataset?.offerId ?? currentTarget?.id ?? ""
        );
        if (!idToDelete || !(idToDelete in offersConsolidation)) return;

        // If only one offer remains, reset it to a blank offer instead of deleting
        if (Object.keys(offersConsolidation).length === 1) {
            const resetOffer = {
                ...DEFAULT_OFFER,
                "id": Number(idToDelete),
                "cutOffTime": selectedDates.reduce((acc, date) => {
                    acc[date] = setCutOffTime(date, stationTime);
                    return acc;
                }, {}),
            };
            setOffersConsolidation({ [idToDelete]: resetOffer });
            setOfferDetails(resetOffer);
            setActiveKey(idToDelete.toString());
            if (showError) setShowError(false);
            return;
        }

        let updatedBatch = { ...offersConsolidation };
        delete updatedBatch[idToDelete];
        if (idToDelete == activeKey) {
            setActiveKey(null);
        }
        setOffersConsolidation(updatedBatch);
        if (showError) {
            const stillHasError = Object.values(updatedBatch).some(offer => offer.error);
            if (!stillHasError) {
                setShowError(false);
            }
        }
    };

    const handleClickHeader = (id) => {
        setActiveKey(id.toString() === activeKey ? null : id.toString());
    };

    const handleSelectStation = async (station) => {
        setSelectedStation(station.toUpperCase());
        let newStationTime = await getStationTimestamp(station.toUpperCase());
        setStationTime(newStationTime);
    const stationMoment = getBaseMoment(newStationTime);
    const nextAvailableDates = buildThreeDatesFromBase(newStationTime);
    setAvailableDates(nextAvailableDates);
    const hour = stationMoment.hour();
    const minute = stationMoment.minute();
    const after2330 = hour > 23 || (hour === 23 && minute >= 30);
    const todayStr = stationMoment.format('MM/DD/YYYY');
    setSelectedDates(prevSelectedDates => prevSelectedDates.filter(date => {
            if (!nextAvailableDates.includes(date)) return false;
            return !(after2330 && date === todayStr);
    }));
        if (selectedDepartment.length>0) {
            setSelectedDepartment("")
        }
        if (selectedWorkLoc.length > 0) {
            setSelectedWorkLoc("");
        }
    };

    /**
     * Handles department selection and fetches classification/duty assignment options.
     * @param {string} dpt - The selected department
     * @param {string} stationOverride - Optional station override. When called from DropdownFilters,
     *        this defaults to selectedStation. When called from applySuggestionDefaults during
     *        initial setup, the suggestion station is passed explicitly since selectedStation
     *        may not be set yet.
     */
    const handleSelectDepartment = async (dpt, stationOverride = selectedStation) => {
        const stationCode = (stationOverride || "").toUpperCase();
        if (!stationCode) {
            setSelectedDepartment(dpt);
            return;
        }
        let classificationCodes = await getClassificationOptions(stationCode, dpt);
        setClassificationOptions(classificationCodes);
        let dutyAssigCodes = await getDutyAssignmentOptions(stationCode, dpt);
        setDutyAssigOptions(dutyAssigCodes);
        setSelectedDepartment(dpt);
    };

    const handleSelectDate = (date) => {
        let currentSelection = [...selectedDates];
        if (selectedDates.includes(date)) {
            if (Object.keys(offersConsolidation).length === 1 && selectedDates.length === 1) return;
            let idxToDelete = currentSelection.indexOf(date);
            currentSelection.splice(idxToDelete, 1);
            let updatedOffers = updateAllOfferErrors(offersConsolidation, currentSelection, stationTime);
            setOffersConsolidation(updatedOffers);
            setSelectedDates(currentSelection);
            setTimeout(() => {
                const errorOffer = Object.values(updatedOffers).find(offer => offer.error);
                setActiveKey(errorOffer ? errorOffer.id.toString() : null);
            }, 0);
        } else {
            let newDate = moment(date);
            const index = currentSelection.findIndex(existingDate => moment(existingDate) > newDate);
            if (index === -1) {
                currentSelection.push(newDate.format('MM/DD/YYYY'));
            } else {
                currentSelection.splice(index, 0, newDate.format('MM/DD/YYYY'));
            }
            if (Object.keys(offersConsolidation).length > 0) {
                const { updatedOffers, errorOfferId } = validateOfferTimes(offersConsolidation, newDate.format('MM/DD/YYYY'), null, stationTime);
                setOffersConsolidation(updatedOffers);
                setSelectedDates(currentSelection);
                if (errorOfferId !== null) {
                    setShowError(true);
                    setActiveKey(errorOfferId.toString());
                } else {
                    setShowError(false);
                    setActiveKey(null);
                }
            } else {
                setSelectedDates(currentSelection);
            }
            if (Object.keys(offersConsolidation).length > 0) {
                let previousOffers = { ...offersConsolidation };
                Object.values(previousOffers).forEach(offer => {
                    let currentOffer = { ...previousOffers[offer.id] };
                    currentOffer.cutOffTime[date] = setCutOffTime(date, stationTime);
                    previousOffers[offer.id] = currentOffer;
                });
                setOffersConsolidation(previousOffers);
            }
        }
    };

    const fillClassificationAndDutyA = () => {
        let previousOffers = { ...offersConsolidation };
        Object.values(previousOffers).forEach(offer => {
            let currentOffer = { ...previousOffers[offer.id] };
            currentOffer.classification = selectedClassification;
            currentOffer.dutyAssignment = selectedDutyAssig;
            previousOffers[offer.id] = currentOffer;
            setShowCDAError(true);
        });
        setOffersConsolidation(previousOffers);
    };

    const handleApplyAllChange = () => {
        if (selectedClassification && selectedDutyAssig) {
            fillClassificationAndDutyA();
        }
        setisCheckedApplyAll(!isCheckedApplyAll);
    };

    const handleSubmitRequest = async () => {
        const allExistingOffers = props.offersTable?.vtoOffers || [];
        const duplicates = checkForDuplicates(allExistingOffers);

        if (duplicates.length > 0) {
            setDuplicateOffers(duplicates);
            setDuplicateResolutions(initializeDuplicateResolutions(duplicates));
            setShowDuplicateModal(true);
            return;
        }
        proceedWithSubmit();
    };

    const proceedWithSubmit = () => {
        // Validate ALL offers for time selection, not just the active one
        const offerIds = Object.keys(offersConsolidation);
        for (const offerId of offerIds) {
            const hasError = hasSelectionError(offerId);
            if (hasError || offersConsolidation[offerId]?.error) {
                setActiveKey(offerId.toString());
                setShowError(true);
                setShowSubmitPopup(false);
                return;
            }
        }

        const { isValid } = validateFields(
            selectedDepartment, selectedDates, selectedStation,
            selectedClassification, selectedDutyAssig, isCheckedApplyAll
        );
        if (!isValid) {
            setShowCDAError(true);
            return;
        }
        setShowCDAError(false);

        // When Apply All is off, validate each offer has its own CDA
        if (!isCheckedApplyAll) {
            for (const offerId of Object.keys(offersConsolidation)) {
                const offer = offersConsolidation[offerId];
                if (offer && (!offer.classification || !offer.dutyAssignment)) {
                    setShowCDAError(true);
                    setActiveKey(offerId.toString());
                    let previousOffers = { ...offersConsolidation };
                    let updatedOffer = { ...offer, cdaError: true };
                    previousOffers[offerId] = updatedOffer;
                    setOffersConsolidation(previousOffers);
                    return;
                }
            }
        }

        if (Object.values(offersConsolidation).some(offer => offer.error)) {
            setShowError(true);
            setShowSubmitPopup(false);
            return;
        }

        let response = buildOffersResponse(
            offersConsolidation, selectedDates, selectedStation,
            selectedDepartment, selectedWorkLoc, selectedClassification, selectedDutyAssig
        );
        setOffersSummary(response);
        setShowSubmitPopup(true);
    };

    const handleConfirmationRequest = () => {
        props.submitOffers(offersSummary);
        setSelectedDepartment("");
        setSelectedClassification("");
        setSelectedDutyAssig("");
    };

const todayStr = getBaseMoment(stationTime).format('MM/DD/YYYY');
const availableDatesFiltered = isAfter2330(stationTime)
    ? availableDates.filter(date => date !== todayStr)
    : availableDates;

    // Apply suggestion defaults on mount
    useEffect(() => {
        const applySuggestionDefaults = async () => {
            if (!suggestionDetails || hasAppliedSuggestion) return;

            const suggestionDateRaw = suggestionDetails.Date || suggestionDetails.date;
            const suggestionStation = suggestionDetails.Station || suggestionDetails.station;
            const suggestionDepartment = suggestionDetails.Department || suggestionDetails.department;

            if (suggestionDateRaw) {
                const parsedSuggestionDate = moment(suggestionDateRaw, ['MM/DD/YYYY', 'M/D/YYYY', 'YYYY-MM-DD'], true);
                if (parsedSuggestionDate.isValid()) {
                    const formattedDate = parsedSuggestionDate.format('MM/DD/YYYY');
                    if (availableDates.includes(formattedDate)) {
                        setSelectedDates([formattedDate]);
                    }
                }
            }

            if (suggestionStation) {
                await handleSelectStation(suggestionStation);
            }

            if (suggestionDepartment) {
                await handleSelectDepartment(suggestionDepartment, suggestionStation || selectedStation);
            }

            setHasAppliedSuggestion(true);
        };

        applySuggestionDefaults();
    }, [suggestionDetails, hasAppliedSuggestion, availableDates]);

    // Sync dateShown with selectedDates
    useEffect(() => {
        if (selectedDates.length > 0 && dateShown !== selectedDates[0]) {
            setDateShown(selectedDates[0]);
        }
    }, [selectedDates]);

    // Main effect for form state changes
    useEffect(() => {
        if (showRequiredFieldsError) {
            const { isValid } = validateFields(
                selectedDepartment, selectedDates, selectedStation,
                selectedClassification, selectedDutyAssig, isCheckedApplyAll
            );
            setShowRequiredFieldsError(!isValid);
        }
        if (selectedClassification && selectedDutyAssig) {
            fillClassificationAndDutyA();
        }
        setIsFlashOffer(selectedDates.includes(todayStr));
    
        if (
            selectedDates.length > 0 &&
            selectedStation.length > 0 &&
            selectedDepartment.length > 0 
        ) {
            // Create search criteria for ALL selected dates instead of just dateShown
            const searchCriteria = [
                { "queryOperator": "IN", "searchField": "offerDate", "value": "", "values": selectedDates },
                { "queryOperator": "EQUALS", "searchField": "station", "value": selectedStation },
                { "queryOperator": "EQUALS", "searchField": "department", "value": selectedDepartment }
            ];

            if (selectedClassification && isCheckedApplyAll) {
                searchCriteria.push({ "queryOperator": "EQUALS", "searchField": "classification", "value": selectedClassification });
            }

            if (selectedDutyAssig && isCheckedApplyAll) {
                searchCriteria.push({ "queryOperator": "EQUALS", "searchField": "dutyAssignment", "value": selectedDutyAssig });
            }

            if (isCheckedApplyAll && selectedDutyAssig && selectedClassification) {
                setShowCDAError(false);
            }

            props.getOffersBatch({
                "searchCriteria": searchCriteria,
                "sortBy": "offerStart",
                "sortOrder": "ASC",
                "pageNumber": 1,
                "size": 500
            });

            if (Object.keys(offersConsolidation).length === 0) {
                handleAddNewOffer();
                setActiveKey("0");
            }
        }

        return () => { props.cleanUpBatch(); };
    }, [selectedClassification, selectedDutyAssig, selectedStation, selectedDepartment, isCheckedApplyAll, selectedDates, todayStr]);

    // Clear CDA error when offer's classification and duty assignment are filled
    useEffect(() => {
        if (!showCDAError) return;

        // Check if all offers have valid C&DA (or if Apply All is checked with valid global C&DA)
        const allOffersHaveValidCDA = Object.values(offersConsolidation).every(offer => {
            if (isCheckedApplyAll) {
                return selectedClassification && selectedDutyAssig;
            }
            return offer.classification && offer.dutyAssignment;
        });

        if (allOffersHaveValidCDA && Object.keys(offersConsolidation).length > 0) {
            setShowCDAError(false);
            // Also clear cdaError on individual offers
            let updatedOffers = { ...offersConsolidation };
            let hasChanges = false;
            Object.values(updatedOffers).forEach(offer => {
                if (offer.cdaError) {
                    updatedOffers[offer.id] = { ...offer, cdaError: false };
                    hasChanges = true;
                }
            });
            if (hasChanges) {
                setOffersConsolidation(updatedOffers);
            }
        }
    }, [offersConsolidation, isCheckedApplyAll, selectedClassification, selectedDutyAssig, showCDAError]);

    // Station list effect
    useEffect(() => {
        if (!props.stationList || props.stationList?.length === 0) {
            props.getStationList(props.userId);
        } else {
            setStationOptions(props.stationList);
        }
        const suggestionStation = location.state?.suggestion?.station || location.state?.suggestion?.Station;
        if (stationOptions?.length === 0 && !suggestionStation) {
            setSelectedStation("");
        }
        // Don't flag station error while list is still loading and we have a suggestion station
        setIsStationError(props.stationList.length === 0 && !suggestionStation);
    }, [props.stationList]);

    // Station list success effect
    useEffect(() => {
        if (typeof props.stationListSuccess === 'boolean') {
            setIsStationError(!props.stationListSuccess);
        }
    }, [props.stationListSuccess]);

    // Fetch station time on offer time change
    useEffect(() => {
        const fetchStationTime = async () => {
            if (selectedStation) {
                let newStationTime = await getStationTimestamp(selectedStation.toUpperCase());
                setStationTime(newStationTime);
            }
        };
        const activeOffer = offersConsolidation[activeKey];
        if (activeOffer && (activeOffer.offerStartTimeHr || activeOffer.offerStartTimeMin)) {
            fetchStationTime();
        }
    }, [offersConsolidation[activeKey]?.offerStartTimeHr, offersConsolidation[activeKey]?.offerStartTimeMin, selectedStation]);

    // Keep available date buttons aligned with station-local day
    useEffect(() => {
        if (!stationTime) return;
        const nextAvailableDates = buildThreeDatesFromBase(stationTime);
        setAvailableDates(nextAvailableDates);
        setSelectedDates(prevSelectedDates => prevSelectedDates.filter(date => nextAvailableDates.includes(date)));
    }, [stationTime]);

    useEffect(() => {
        if (typeof props.slotsUpdateSuccess === "boolean") {
            if (props.slotsUpdateSuccess) {
                const updatedDuplicates = duplicateOffers.filter(duplicate =>
                    duplicate.existingOffer?.offerId !== selectedOfferForSlots?.offerId
                );
                setDuplicateOffers(updatedDuplicates);
                const offersToRemove = duplicateOffers.filter(duplicate =>
                    duplicate.existingOffer?.offerId === selectedOfferForSlots?.offerId
                );
                let updatedOffersConsolidation = { ...offersConsolidation };
                offersToRemove.forEach(duplicateToRemove => {
                    const idToRemove = duplicateToRemove.newOffer?.id;
                    if (idToRemove !== undefined) delete updatedOffersConsolidation[idToRemove];
                });
                setOffersConsolidation(updatedOffersConsolidation);
                const remainingOfferCount = Object.keys(updatedOffersConsolidation).length;
                if (remainingOfferCount > 0) {
                    let response = buildOffersResponse(
                        updatedOffersConsolidation, selectedDates, selectedStation,
                        selectedDepartment, selectedWorkLoc, selectedClassification, selectedDutyAssig
                    );
                    setOffersSummary(response);
                    setShowSubmitPopup(true);
                } else {
                    setShowSlotsSuccessModal(true);
                }
                if (selectedStation && selectedDepartment && selectedDates.length > 0) {
                    const searchCriteria = createSearchCriteria(dateShown, selectedStation, selectedClassification, selectedDutyAssig, isCheckedApplyAll);
                    props.getOffersBatch({
                        "searchCriteria": searchCriteria,
                        "sortBy": "offerStart",
                        "sortOrder": "ASC",
                        "pageNumber": 1,
                        "size": 500
                    });
                }
            } else if (props.slotsUpdateSuccess === false) {
                alert(`${props.slotsUpdateError?.title || 'Error updating slots'} ${props.slotsUpdateError?.detail || 'Please try again.'}`);
            }
            props.resetSlotsUpdateSuccess();
        }
    }, [props.slotsUpdateSuccess, props.slotsUpdateError]);

    // Auto-uncheck "Apply All" when vtoOpportunities has multiple role types
    useEffect(() => {
        if (hasMultipleRoleTypes() && isCheckedApplyAll) {
            setisCheckedApplyAll(false);
        }
    }, [vtoOpportunities, isCheckedApplyAll]);

    // ==================== Card Position Logic ====================
    const updateCardPosition = useCallback(() => {
        if (!accordionRef.current) return;

        const containerRect = accordionRef.current.parentElement?.getBoundingClientRect();
        const accordionRect = accordionRef.current.getBoundingClientRect();

        if (activeKey !== null && accordionItemRefs.current[activeKey]) {
            // Position card at the top of the active accordion item
            const activeItemRect = accordionItemRefs.current[activeKey].getBoundingClientRect();
            const relativeTop = activeItemRect.top - (containerRect?.top || 0);
            setCardTopPosition(relativeTop + 26);
        } else {
            // Position card at the bottom of the accordion
            const relativeBottom = accordionRect.bottom - (containerRect?.top || 0);
            setCardTopPosition(relativeBottom + 26); // 16px gap
        }
    }, [activeKey]);

    // Update card position when activeKey changes or on resize
    useEffect(() => {
        updateCardPosition();

        window.addEventListener('resize', updateCardPosition);
        return () => window.removeEventListener('resize', updateCardPosition);
    }, [activeKey, updateCardPosition, offersConsolidation]);

    // Delayed update after accordion animation completes
    useEffect(() => {
        const timer = setTimeout(updateCardPosition, 350);
        return () => clearTimeout(timer);
    }, [activeKey, updateCardPosition]);

    // ==================== Render ====================
    return (
        <div style={{ marginLeft: 50, marginRight: 50 }}>
            {/* Confirmation Popup */}
            {showSubmitPopup && (
                <ConfirmationPopUp
                    title={"Offers Summary"}
                    headers={["", "", "Offer", "Duration", "Slots", "Classification", "Duty Assignment", "Cut Off Time"]}
                    showModal={showSubmitPopup}
                    selectedList={offersSummary.offers || []}
                    availableDates={availableDates}
                    handleConfirmationRequest={handleConfirmationRequest}
                    setShowModal={setShowSubmitPopup}
                    showConfirmationLoader={props.showConfirmationLoader}
                    confirmedBatch={props.confirmedBatch}
                    showConfirmData={props.showConfirmData}
                    batchSubmitted={props.batchSubmitted}
                    cleanUpBatch={() => {
                        setOffersConsolidation({});
                        props.cleanUpBatch();
                    }}
                    recallEmployeeBatch={null}
                />
            )}

            {/* Duplicate Offer Modal */}
            <DuplicateOfferModal
                showDuplicateModal={showDuplicateModal}
                duplicateOffers={duplicateOffers}
                duplicateResolutions={duplicateResolutions}
                setDuplicateResolutions={setDuplicateResolutions}
                handleConfirmDuplicateResolutions={handleConfirmDuplicateResolutions}
                setShowDuplicateModal={setShowDuplicateModal}
                setDuplicateOffers={setDuplicateOffers}
            />

            {/* Slots Success Modal */}
            <SlotsSuccessModal
                showSlotsSuccessModal={showSlotsSuccessModal}
                setShowSlotsSuccessModal={setShowSlotsSuccessModal}
                setSelectedOfferForSlots={setSelectedOfferForSlots}
                setDuplicateOffers={setDuplicateOffers}
                history={history}
            />

            {/* Auto-Fill Confirmation Popup */}
            <AutoFillConfirmationPopup
                show={showAutoFillPopup}
                pendingAutoFillData={pendingAutoFillData}
                onOverwrite={handleAutoFillOverwrite}
                onCreateNew={handleAutoFillCreateNew}
                onCancel={closeAutoFillPopup}
            />

            {/* Suggestion Popup */}
            {suggestionDetails && (
                <SuggestionPopup
                    showModal={showSuggestionModal}
                    setShowModal={setShowSuggestionModal}
                    timeRange={suggestionDetails.timeframe?.startTime + " - " + suggestionDetails.timeframe?.endTime}
                    totalEmployees={suggestionDetails.totalEmp}
                    estimatedNeed={suggestionDetails.neededEmp}
                    overStaffedGroups={suggestionDetails.Classification}
                />
            )}

            {/* Back Button */}
            <a className="navigation-tree" style={{ cursor: 'pointer' }} onClick={() => history.goBack()}>&lt;{strings.backButton}</a>
            <div style={{ marginLeft: 20 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div>
                        <div className="subtitle" style={{ marginTop: 20 }}>Create New VTO Offer</div>

                        {/* Date Selection */}
                        <DateSelector
                            availableDates={availableDates}
                            selectedDates={selectedDates}
                            onSelectDate={handleSelectDate}
                            isAfter2330={isAfter2330}
                            stationTime={stationTime}
                            todayStr={todayStr}
                            isFlashOffer={isFlashOffer}
                        />

                        {/* Dropdown Filters */}
                        <DropdownFilters
                            stationOptions={stationOptions}
                            selectedStation={selectedStation}
                            onSelectStation={handleSelectStation}
                            isStationError={isStationError}
                            departmentOptions={departmentOptions}
                            selectedDepartment={selectedDepartment}
                            onSelectDepartment={handleSelectDepartment}
                            classificationOptions={classificationOptions}
                            selectedClassification={selectedClassification}
                            onSelectClassification={setSelectedClassification}
                            dutyAssigOptions={dutyAssigOptions}
                            selectedDutyAssig={selectedDutyAssig}
                            onSelectDutyAssig={setSelectedDutyAssig}
                            isCheckedApplyAll={isCheckedApplyAll}
                            onApplyAllChange={handleApplyAllChange}
                            showCDAError={showCDAError}
                        />
                    </div>

                    {/* Current Offers Panel */}
                    <CurrentOffers
                        offersBatch={props.offersTable}
                        selectedDates={selectedDates}
                        dateShown={dateShown}
                        setDateShown={setDateShown}
                        selectedDepartment={selectedDepartment}
                        selectedStation={selectedStation}
                        offersFound={props.offersTable.offersFound}
                    />
                </div>

                {/* Offers Accordion with Suggestion Card */}
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '24px',
                    alignItems: 'flex-start',
                    marginTop: 40,
                    position: 'relative'
                }}>
                    <div ref={accordionRef} style={{ flex: 1 }}>
                        {Object.keys(offersConsolidation).length > 0 && (
                            <Accordion defaultActiveKey="0" activeKey={activeKey}>
                                {Object.values(offersConsolidation).map((offer, idx) => {
                                    const headerStyle = offer.error ? { border: '2px solid red', borderRadius: 10 } : {};
                                    return (
                                        <div key={offer.id} className="offer-header" ref={el => accordionItemRefs.current[offer.id] = el}>
                                            <div style={headerStyle}>
                                                <NewOfferComponent
                                                    handleDeleteOffer={handleDeleteOffer}
                                                    idx={offer.id}
                                                    id={offer.id}
                                                    offerDetailsSelected={offer}
                                                    offersConsolidation={offersConsolidation}
                                                    setOffersConsolidation={setOffersConsolidation}
                                                    setOfferDetails={setOfferDetails}
                                                    activeKey={activeKey}
                                                    setActiveKey={setActiveKey}
                                                    handleClickHeader={handleClickHeader}
                                                    showError={offer.error}
                                                    setShowError={setShowError}
                                                    hasSelectionError={hasSelectionError}
                                                    handleAddNewOffer={handleAddNewOffer}
                                                    isFlashOffer={isFlashOffer}
                                                    isCheckedApplyAll={isCheckedApplyAll}
                                                    classificationOptions={classificationOptions}
                                                    dutyAssigOptions={dutyAssigOptions}
                                                    setShowCDAError={setShowCDAError}
                                                    selectedClassification={selectedClassification}
                                                    selectedDutyAssig={selectedDutyAssig}
                                                    selectedDates={selectedDates}
                                                    availableDates={availableDates}
                                                    setCutOffTime={setCutOffTime}
                                                    validateOfferTimes={(startTime, endTime, selectedDate) =>
                                                        validateOfferTimes(startTime, endTime, selectedDate, stationTime)
                                                    }
                                                    stationTime={stationTime}
                                                />
                                            </div>
                                        </div>
                                    );
                                })}
                            </Accordion>
                        )}
                    </div>

                    {/* VTO Opportunities Card - Positioned relative to active accordion item */}
                    {showSuggestion && suggestionDetails && suggestionDetails.timeframe && suggestionDetails.cardDetails && (
                        <div id="vto-predictions" style={{
                            position: 'absolute',
                            right: 0,
                            top: cardTopPosition,
                            transition: 'top 0.3s ease-in-out',
                            maxHeight: 'calc(100vh - 200px)',
                            zIndex: 10
                        }}>
                            <Card className="vto-suggestion-card" style={{ width: '360px', boxShadow: '0 4px 12px rgba(0,0,0,0.15)', backgroundColor: "#F9FAFB" }}>
                                <Card.Header className="extra-styling">
                                    <div className="card-header" style={{ fontSize: '18px' }}>
                                        <span>Suggested Offer</span>
                                        {/* <span><img src={infoIcon} width={16} height={16} alt="Info" style={{ cursor: 'pointer' }} /></span> */}
                                    </div>
                                </Card.Header>

                                <div className="card-header extra-styling">
                                    <span>{suggestionDetails.timeframe.startTime}-{suggestionDetails.timeframe.endTime}</span>
                                </div>

                                <div className="card-header__worklocation">{suggestionDetails.workLocation}</div>

                                {suggestionDetails.cardDetails.vtoOpportunities?.map((opportunity, j) => (
                                    <div key={j} style={{ padding: 0, width: '100%' }}>
                                        <div className="card-header__roletype" >{opportunity.roleType}</div>


                                        {/* Full Shift */}
                                        {opportunity.fullShift && opportunity.fullShift.vtoOp > 0 && (
                                            <Card.Body className="card-header" style={{ margin: 0, borderTop: '1px solid #e9ecef', padding: '8px 0', width: '100%' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                                        <span className="card-text" style={{ fontSize: '14px' }}>Full Shift</span>
                                                        <div className="vto-offer-pill" style={{ display: 'inline-flex', alignItems: 'center' }}>
                                                            <img src={LeadingIcon} className="vto-icon-orange" alt="Icon" width={16} height={16} />
                                                            <span style={{ fontSize: '12px' }}>{opportunity.fullShift.vtoOp}</span>
                                                        </div>
                                                    </div>
                                                    <Button
                                                        variant={addedOffers.has(`${opportunity.roleType}-${suggestionDetails.timeframe.startTime}-${suggestionDetails.timeframe.endTime}`) ? "secondary" : "outline-primary"}
                                                        size="sm"
                                                        className="add-to-form-btn"
                                                        disabled={addedOffers.has(`${opportunity.roleType}-${suggestionDetails.timeframe.startTime}-${suggestionDetails.timeframe.endTime}`)}
                                                        onClick={() => {
                                                            const success = handleAutoFillOffer({
                                                                startTime: suggestionDetails.timeframe.startTime,
                                                                endTime: suggestionDetails.timeframe.endTime,
                                                                vtoOp: opportunity.fullShift.vtoOp,
                                                                roleType: opportunity.roleType
                                                            });
                                                            if (success) {
                                                                setAddedOffers(prev => new Set(prev).add(`${opportunity.roleType}-${suggestionDetails.timeframe.startTime}-${suggestionDetails.timeframe.endTime}`));
                                                            }
                                                        }}
                                                    >
                                                        {addedOffers.has(`${opportunity.roleType}-${suggestionDetails.timeframe.startTime}-${suggestionDetails.timeframe.endTime}`) ? "Added" : "Add to form"}
                                                    </Button>
                                                </div>
                                            </Card.Body>
                                        )}

                                        {/* Partial Shifts */}
                                        {opportunity.partialShifts?.map((partial, k) => (
                                            <Card.Body key={k} className="card-header" style={{ margin: 0, borderTop: '1px solid #e9ecef', padding: '8px 0', width: '100%' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                                        <span className="card-text" style={{ fontSize: '14px' }}>{partial.startTime}-{partial.endTime} (Partial)</span>
                                                        <div className="vto-offer-pill" style={{ display: 'inline-flex', alignItems: 'center' }}>
                                                            <img src={LeadingIcon} className="vto-icon-orange" alt="Icon" width={16} height={16} />
                                                            <span style={{ fontSize: '12px' }}>{partial.vtoOp}</span>
                                                        </div>
                                                    </div>
                                                    <Button
                                                        variant={addedOffers.has(`${opportunity.roleType}-${partial.startTime}-${partial.endTime}`) ? "secondary" : "outline-primary"}
                                                        className="add-to-form-btn"
                                                        disabled={addedOffers.has(`${opportunity.roleType}-${partial.startTime}-${partial.endTime}`)}
                                                        onClick={() => {
                                                            const success = handleAutoFillOffer({
                                                                startTime: partial.startTime,
                                                                endTime: partial.endTime,
                                                                vtoOp: partial.vtoOp,
                                                                roleType: opportunity.roleType
                                                            });
                                                            if (success) {
                                                                setAddedOffers(prev => new Set(prev).add(`${opportunity.roleType}-${partial.startTime}-${partial.endTime}`));
                                                            }
                                                        }}
                                                    >
                                                        {addedOffers.has(`${opportunity.roleType}-${partial.startTime}-${partial.endTime}`) ? "Added" : "Add to form"}
                                                    </Button>
                                                </div>
                                            </Card.Body>
                                        ))}
                                    </div>
                                ))}
                            </Card>
                        </div>
                    )}
                </div>

                {/* Add New Offer & Submit Buttons */}
                <div style={{ display: "flex", flexDirection: "column", alignItems: 'flex-start' }}>
                    <button
                        className={`addoffer-title ${showError ? "disabled" : ""}`}
                        disabled={showError}
                        style={{ margin: '30px 0px' }}
                        onClick={() => {
                            const { isValid } = validateFields(
                                selectedDepartment, selectedDates, selectedStation,
                                selectedClassification, selectedDutyAssig, isCheckedApplyAll
                            );
                            if (!isValid) {
                                setShowRequiredFieldsError(true);
                                setShowCDAError(true);
                                return;
                            }
                            setShowRequiredFieldsError(false);
                            setShowCDAError(false);
                            handleAddNewOffer(offerDetails);
                        }}
                    >
                        + Add new offer {showRequiredFieldsError && (
                            selectedDates.length > 0
                                ? <p style={{ color: "#D20000" }}>*Select Required fields</p>
                                : <p style={{ color: "red" }}>*Select Dates</p>
                        )}
                    </button>
                    <div style={{ display: 'flex' }}>
                        <Button
                            variant="primary"
                            disabled={
                                Object.keys(offersConsolidation).length === 0 ||
                                Object.values(offersConsolidation).some(offer => offer.error) ||
                                showRequiredFieldsError || showCDAError
                            }
                            onClick={handleSubmitRequest}
                            className={`button-regular cancel ${(Object.keys(offersConsolidation).length === 0 ||
                                    Object.values(offersConsolidation).some(offer => offer.error)) && "disabled"
                                }`}
                            style={{ marginBottom: 50 }}
                        >
                            Submit
                        </Button>
                        {(showRequiredFieldsError || showCDAError) && (
                            <p className="error" style={{ color: "#D20000" }}>*Select Required fields</p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

// ==================== Redux ====================
const mapStateToProps = (state) => ({
    stationCode: state.AuthenticationReducer.station,
    userId: state.AuthenticationReducer.userId,
    firstName: state.AuthenticationReducer.firstName,
    lastName: state.AuthenticationReducer.lastName,
    offersTable: state.VTOReducer.offersTable?.[0] || {},
    stationList: state.VTOReducer.stationList,
    batchSubmitted: state.VTOReducer.batchSubmitted,
    confirmedBatch: state.VTOReducer.confirmedBatch,
    showConfirmData: state.VTOReducer.showConfirmData,
    showConfirmationLoader: state.VTOReducer.showSearchLoader,
    stationListSuccess: state.VTOReducer.stationListSuccess,
    slotsUpdateSuccess: state.VTOReducer.slotsUpdateSuccess,
    slotsUpdateError: state.VTOReducer.slotsUpdateError,
    suggestion: state.VTOReducer.suggestion,
});

const mapDispatchToProps = (dispatch) => ({
    getOffersBatch: (params) => dispatch({ type: vtoConstants.OFFERS_TABLE_BATCH, params }),
    getStationList: (params) => dispatch({ type: vtoConstants.GET_VTO_STATION_LIST, params }),
    cleanUpBatch: () => dispatch({ type: vtoConstants.CLEAN_UP, params: true }),
    submitOffers: (params) => dispatch({ type: vtoConstants.SUBMIT_OFFERS_BATCH, params }),
    updateSlotsRequest: (params) => dispatch({ type: vtoConstants.UPDATE_SLOTS, params }),
    resetSlotsUpdateSuccess: () => dispatch({ type: vtoConstants.UPDATE_SLOTS_SUCCESS, params: { data: null } }),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateOfferscreen);
